export default __webpack_public_path__ + "assets/Manager3.png";